<template>
  <div class="cardtransfer">
    <div class="item">
      <label class="hd">转赠手机号</label>
      <div class="bd"><input v-model="tel" class="weui-input" type="tel" placeholder="请输入手机号"/></div>
    </div>
    <div class="item">
      <div class="bd">
        <textarea v-model="note" class="weui-textarea" placeholder="请输入祝福语" rows="5"></textarea></div>
    </div>
    <div class="app-btn-area weui-btn-area">
      <div @click="couponSent" class="weui-btn">确认转赠</div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      id:0,
      tel:'',
      note:''
    }
  },
  mounted(){
    this.id = this.$route.query.id
  },
  methods:{
    couponSent(){
      let vm = this;
      if(!(vm.id>0)){
        vm.publics.message.danger('该优惠券不存在！');
        return false;
      }
      if(!/^1[2-9]\d{9}$/.test(vm.tel)){
          vm.publics.message.danger('请输入正确的手机号码');
          return false;
      }
      vm.ajax("account/coupon/sent", "post", {
        id:vm.id,
        tel:vm.tel,
        note:	vm.note
      }, e => {
        vm.publics.message.success('转赠成功');
        setTimeout(() => {
          vm.$router.go(-1)
        }, 2000);
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/cardtransfer.vue